import React from 'react';

const Pricing = () => (
    <section className="pricing-section">
        <div className="shape">
            <img src="image/landing-2-shape.svg" />
        </div>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="section-title text-center">
                        <h2>Mark your next step</h2>
                        <p>We designed and tested prototypes that helped identify pain points in the account creation
                            process. Together, we shaped the new standard.</p>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="btn--toggle-pricing" data-tab-target="#pricing-tab-7">
                        <p>Monthly</p>
                        {/*<label className="switch">*/}
                        {/*    <input type="checkbox">*/}
                        {/*        <span className="slider round"></span>*/}
                        {/*</label>*/}
                        <p>Yearly</p>
                    </div>
                </div>

            </div>
            <div className="custom-tab-wrapper monthly" id="pricing-tab-7">
                <div className="row mb-d-30">
                    <div className="col-lg-4">
                        <div className="pricing-card">

                            <div className="card-head">
                                <h6>Basic</h6>
                                <h2><span className="small-title">$</span><span className="big-txt" data-monthly='19'
                                                                                data-yearly='14'>19</span><span
                                    className="month" data-monthly='/month' data-yearly='/year'>/month</span></h2>
                                <p>Good for small business launching their products less then once a year</p>
                            </div>

                            <div className="card-content">
                                <ul className="pricing-list">
                                    <li><span><i className="icon icon-check-2"></i></span>Unlimited Blocks</li>
                                    <li><span><i className="icon icon-check-2"></i></span>5GB Clould Storages</li>
                                    <li className="disable-opt"><span><i className="icon icon-check-2"></i></span>Custom
                                        Domain
                                        Names
                                    </li>
                                    <li className="disable-opt"><span><i className="icon icon-check-2"></i></span>Unlimited
                                        Emails
                                    </li>
                                </ul>
                                <div className="card-btn">
                                    <a href="" className="btn btn--primary">Start Free Trial</a>
                                </div>
                                <p>No credit card required</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="pricing-card active">

                            <div className="card-head">
                                <h6>Pro</h6>
                                <span className="card-badge">Popular</span>
                                <h2><span className="small-title">$</span><span className="big-txt" data-monthly='29'
                                                                                data-yearly='25'>29</span><span
                                    className="month" data-monthly='/month' data-yearly='/year'>/month</span></h2>
                                <p>Good for small business launching their products less then once a year</p>
                            </div>


                            <div className="card-content">
                                <ul className="pricing-list">
                                    <li><span><i className="icon icon-check-2"></i></span>Unlimited Blocks</li>
                                    <li><span><i className="icon icon-check-2"></i></span>5GB Clould Storages</li>
                                    <li><span><i className="icon icon-check-2"></i></span>Custom Domain Names</li>
                                    <li className="disable-opt"><span><i className="icon icon-check-2"></i></span>Unlimited
                                        Emails
                                    </li>
                                </ul>
                                <div className="card-btn">
                                    <a href="" className="btn btn--primary">Start Free Trial</a>
                                </div>
                                <p>No credit card required</p>
                            </div>
                        </div>
                    </div>


                    <div className="col-lg-4">
                        <div className="pricing-card">

                            <div className="card-head">
                                <h6>Exclusive</h6>
                                <h2><span className="small-title">$</span><span className="big-txt" data-monthly='59'
                                                                                data-yearly='49'>59</span><span
                                    className="month" data-monthly='/month' data-yearly='/year'>/month</span></h2>
                                <p>Good for small business launching their products less then once a year</p>
                            </div>


                            <div className="card-content">
                                <ul className="pricing-list">
                                    <li><span><i className="icon icon-check-2"></i></span>Unlimited Blocks</li>
                                    <li><span><i className="icon icon-check-2"></i></span>5GB Clould Storages</li>
                                    <li><span><i className="icon icon-check-2"></i></span>Custom Domain Names</li>
                                    <li><span><i className="icon icon-check-2"></i></span>Unlimited Emails</li>
                                </ul>
                                <div className="card-btn">
                                    <a href="" className="btn btn--primary">Start Free Trial</a>
                                </div>
                                <p>No credit card required</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="pricing-extra-info">
                            <p><span>Still confused?</span><a href="#">Check our full feature list</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Pricing;



// WEBPACK FOOTER //
// ./src/components/Pricing.js